import { menuItem } from '@stereoagency/sanity-schema';
import { LinkComponentProps } from '@stereoagency/ui';
import linkAsProps from './linkAsProps';

type MenuItem = typeof menuItem.schema.menuItem;
type InputType = Omit<MenuItem, 'submenuItems'> & {
  submenuItems?: Partial<NonNullable<MenuItem['submenuItems']>[number]>[];
};

export default function menuItemAsLink(input: InputType): LinkComponentProps {
  return {
    label: input.label,
    ...linkAsProps(input.link)
  };
}
